import React, { Component } from 'react';
import BaseBtn from '../BaseBtn';

class CategoryIn extends Component {
    render() {
        const { categoryName, categoryState, title, section, color, btnName, link } = this.props;
        return (
            <div className={`category ${categoryName} ${categoryState}`}>
                <h3 className="screenOut">{categoryName}</h3>
                <dl className="categoryBox">
                    <dt className="title"><span>{categoryName}</span></dt>
                    <dd className="contents">
                        <div>
                            <div className="section">
                                <span className="index">{section}</span>
                                <strong className="name">{title}</strong>
                            </div>
                            <BaseBtn btnColor={color} btnName={btnName} link={link} section={section} title={title} />
                        </div>
                    </dd>
                </dl>
            </div>
        );
    }
}

CategoryIn.defaultProps = {
    categoryName: 'categoryName',
    categoryState: 'off'
}

export default CategoryIn;


// WEBPACK FOOTER //
// ./src/components/Buttons/CategoryIn/index.js